import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import Sidebar from "src/components/common/Sidebar";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { CRYPTO_SECRET_KEY, RODEO_PAGE_NAME, replaceNbsp } from "src/_config";
import parse from "html-react-parser";
import {
  useAppPerformanceListSelector,
  useAppRodeoEventSettingsSelector,
} from "src/_common/hooks/selectors/eventSelector";
import Sponsor from "src/components/common/Sponsor";
import moment from "moment";

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function ChallengeDetailsPage() {
  const { eventId, performanceId, challengeId } = useParams<any>();
  const eventApi = useEventApi();
  const toast = useToaster();
  const [challengeData, setChallengeData] = useState<any>();
  const performanceList = useAppPerformanceListSelector();

  const getChallengeDetails = () => {
    let params = {
      rodeo_event_id: cryptr.decrypt(eventId),
      performance_id: cryptr.decrypt(performanceId),
      id: cryptr.decrypt(challengeId),
      // id: 2,
    };
    eventApi.callGetChallengeDetails(
      params,
      (message: any, resp: any) => {
        console.log({ resp });
        setChallengeData(resp);
      },
      (message: any) => {
        // toast.error(message);
      }
    );
  };

  useEffect(() => {
    getChallengeDetails();
  }, []);

  return (
    <React.Fragment>
      <div className="main-content-panel">
        <div className="team-list-panel pt-3">
          <div className="d-flex justify-content-between align-items-center team-list-title-panel gap-3">
            <div className="team-list-title">
              <h1>{performanceList?.find((x: any) => x.id == cryptr.decrypt(performanceId))?.title}</h1>
            </div>
            <div className="team-list-date">
              <p>
                {performanceList?.find((x: any) => x.id == cryptr.decrypt(performanceId))?.pdate
                  ? moment(performanceList?.find((x: any) => x.id == cryptr.decrypt(performanceId))?.pdate).format(
                      "MMM DD, YYYY"
                    )
                  : ""}
              </p>
            </div>
          </div>
        </div>
        <div className="main-content-header">
          <div className="main-content-title">
            <h1 className="challenge-header-text">Challenge Details</h1>
          </div>
        </div>
        <div className="comp-box-wrap">
          <div
            className={
              "comp-box " +
              (challengeData?.scores[0]?.total_point > 0 && challengeData?.scores?.length >= 2 ? "winner" : "")
            }
          >
            <div className="comp-text">
              <h2>
                {challengeData?.scores?.length >= 1
                  ? challengeData?.scores[0]?.user_details?.display_name
                  : challengeData?.challenge_details?.home_user_details?.display_name}
              </h2>
              <p>{challengeData?.scores?.length >= 1 ? challengeData?.scores[0]?.total_point || 0 : 0} points</p>
            </div>
          </div>
          <div className="vs-box-comp">
            <img src="/images/vs-graphics.png" alt="" />
          </div>
          <div className="comp-box">
            <div className="comp-text">
              <h2>
                {(challengeData?.scores?.length >= 2
                  ? challengeData?.scores[1]?.user_details?.display_name
                  : challengeData?.scores?.length == 1
                  ? challengeData?.challenge_details?.home_user_id == challengeData?.scores[0]?.user_id
                    ? challengeData?.challenge_details?.away_user_details?.display_name
                    : challengeData?.challenge_details?.home_user_details?.display_name
                  : challengeData?.challenge_details?.away_user_details?.display_name) || "No Opponent"}
              </h2>
              <p>{challengeData?.scores?.length >= 2 ? challengeData?.scores[1]?.total_point || 0 : 0} points</p>
            </div>
          </div>
        </div>
      </div>

      <Sponsor />
    </React.Fragment>
  );
}
